import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { isNull } from 'lodash';
import TagRejectModal from '../../../../views/app/common/modal/TagRejectModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class TagRejectModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: null,
      reason: '',
    };
  }

  onChange = (data) => {
    const { name, value } = data;

    this.setState({
      [name]: value,
    });
  };

  closeModal = () => {
    const { appToggleModal } = this.props;

    appToggleModal({
      name: 'tagRejectModal',
    });
  };

  rejectTag = () => {
    const { rejectTag } = this.props.data;
    const { type, reason } = this.state;

    if (isNull(type)) {
      message.error('거절타입을 입력하셔야 합니다.');
      return;
    } else if (!reason) {
      message.error('거절 상세 사유를 입력하셔야 합니다.');
      return;
    }

    rejectTag({
      type,
      reason,
    });

    this.closeModal();
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <TagRejectModal
        {...this.state}
        isOpen={isOpen}
        data={data}
        onChange={this.onChange}
        closeModal={this.closeModal}
        rejectTag={this.rejectTag}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.tagRejectModal.isOpen,
    data: state.app.tagRejectModal.data,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(TagRejectModalContainer));
